module.exports = __webpack_public_path__ + "static/media/icon-font.5f521fea.eot";